
import React from 'react';
import { Camera, Image, Video, FileText } from 'lucide-react';
import ComingSoonLayout from '../components/layout/ComingSoonLayout';

const Dokumentasi: React.FC = () => {
  return (
    <ComingSoonLayout
      title="Dokumentasi"
      subtitle="Gallery & Documentation"
      description="Halaman ini akan menampilkan galeri foto dan video kegiatan KKN, laporan harian, artikel, dan dokumentasi lengkap perjalanan tim KKN di Desa Karangmalang."
      icon={<Camera className="h-12 w-12 sm:h-16 sm:w-16 text-white" />}
     
      estimatedDate="Gallery Coming Soon"
    />
  );
};

export default Dokumentasi;